import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { BaseCell, BaseHeader } from './Column';
import { IEnrichedFlight } from '../../../../shared/flight/domain/models/IEnrichedFlight';
import { useFlightDetailUrl } from '../../../../detail/ui/helpers/useFlightDetailUrl';
import {
	ArrowForwardIcon,
	Css,
	Responsive,
	StyledIconLink,
	StyledLinkText,
	VisuallyHidden,
} from '../../../../../../ui';
import LinkButton from '../../../../../../components/common/button/LinkButton';
import { FlightListScope } from '../../../domain/constants/FlightListScope';

interface IProps {
	flight: IEnrichedFlight;
	scope: FlightListScope;
}

const styles = css`
	display: flex;
	max-width: 88px;
	text-align: right;
	${StyledIconLink} {
		white-space: nowrap;

		${StyledLinkText} {
			text-overflow: initial;
			overflow: initial;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 65px;
		margin-top: ${Css.pxToRem(8)};
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
	justify-content: flex-end;
`;

export function Header() {
	return <StyledHeader />;
}

export function Cell({ flight, scope }: IProps) {
	const href = useFlightDetailUrl(flight, scope);
	return (
		<StyledCell>
			<LinkButton
				href={href}
				aria-label="View flight details"
				buttonType="text"
				icon={<ArrowForwardIcon aria-hidden="true" />}
			>
				Details
				<VisuallyHidden>
					for flight {flight.codeShareFlightNumber}
				</VisuallyHidden>
			</LinkButton>
		</StyledCell>
	);
}
